import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import SuiTypography from "components/SuiTypography";

const ResumenCuotas = memo(({ clase, proyeccionData }) => {
  const maxCuotas = useMemo(() => {
    if (!proyeccionData?.proyeccion) return 0;

    // Encontrar el número más alto de cuota entre todas las clases
    return Object.values(proyeccionData.proyeccion).reduce((maxCuota, claseData) => {
      const ultimaCuota = claseData?.ultima_cuota || claseData?.proyeccion?.length || 0;
      return Math.max(maxCuota, ultimaCuota);
    }, 0);
  }, [proyeccionData]);

  // Obtener el número de cuotas para la clase actual
  const cuotasClase = useMemo(() => {
    if (!proyeccionData?.proyeccion?.[clase]) return 0;
    return (
      proyeccionData.proyeccion[clase].ultima_cuota ||
      proyeccionData.proyeccion[clase].proyeccion?.length ||
      0
    );
  }, [proyeccionData, clase]);

  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
      <Grid size={6} display="flex" justifyContent="center" alignItems="center">
        <SuiTypography variant="body2" fontWeight="bold" sx={{ color: "#999999 !important" }}>
          Última Cuota Clase: {cuotasClase}
          {proyeccionData?.proyeccion?.[clase]?.fecha_final &&
            ` (hasta ${proyeccionData.proyeccion[clase].fecha_final})`}
        </SuiTypography>
      </Grid>
      <Grid size={6} display="flex" justifyContent="center" alignItems="center">
        <SuiTypography variant="body2" fontWeight="bold" sx={{ color: "#999999 !important" }}>
          Total Cuotas todas las Clases: {maxCuotas}
        </SuiTypography>
      </Grid>
    </Grid>
  );
});

ResumenCuotas.displayName = "ResumenCuotas";

ResumenCuotas.propTypes = {
  clase: PropTypes.string.isRequired,
  proyeccionData: PropTypes.object,
};

export default ResumenCuotas;
